import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getLembur = createAsyncThunk(
    "lembur/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSetupLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertLembur = createAsyncThunk(
    "lembur/insert",
    async ({namaLembur, golonganID, tipeKaryawanID, jumlahLembur, tiketPesawat}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaLembur", namaLembur);
        formData.append("golonganID", golonganID);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        formData.append("jumlahLembur", jumlahLembur);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertSetupLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateLembur = createAsyncThunk(
    "lembur/update",
    async ({setupLemburID, namaLembur, golonganID, tipeKaryawanID, jumlahLembur, tiketPesawat, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("setupLemburID", setupLemburID);
        formData.append("namaLembur", namaLembur);
        formData.append("golonganID", golonganID);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        formData.append("jumlahLembur", jumlahLembur);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateSetupLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const lemburSlice = createSlice({
    name: "lembur",
    initialState,
    reducers: {},
    extraReducers: {
        [getLembur.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getLembur.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getLembur.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertLembur.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertLembur.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertLembur.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateLembur.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateLembur.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateLembur.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const lemburSelector = (state) => state.lembur;
